<template>
  <c-expansion-panel>
    <template v-slot:header="{ expand }">
      <div class="pa-4">
        <v-layout align-center class="pa-1 unselectable">
          <div class="headline font-weight-medium">
            Packaging ({{ items.length }})
          </div>
          <div class="c-hr" style="flex-grow: 1;">
          </div>
          <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
        </v-layout>
      </div>
    </template>
    <template v-slot:body>
      <div>
        <v-layout align-center pl-2 pr-2>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
              @click="selectAll">
                <v-list-tile-title>Select all</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
              @click="selectPage">
                <v-list-tile-title>Select page</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
              @click="selectNone">
                <v-list-tile-title>Select none</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <transition
          name="slide-y-reverse-transition"
          mode="out-in">
            <div v-if="selectedCount > 0"
            key="1"
            class="c-flex-r align-center subheading">
              <v-btn
              icon
              class="ma-0"
              @click="selected = {}">
                <v-icon color="color1">close</v-icon>
              </v-btn>
              <div class="text-sans font-weight-medium">
                <span>&nbsp;{{ selectedCount }}</span>
                selected 
              </div>
              <span class="icon--text ml-2">|</span>
              <v-btn 
              icon
              @click="onDelete">
                <v-icon>delete_outline</v-icon>
              </v-btn>
              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                  @click="selectAll">
                    <v-list-tile-title>Select all</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                  @click="selectPage">
                    <v-list-tile-title>Select page</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                  @click="selectNone">
                    <v-list-tile-title>Select none</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
            <div v-else>
              <v-btn 
              text color="color1" class="ma-0"
              @click="selectOutput">
                Add item
              </v-btn>
            </div>
          </transition>
          <v-spacer></v-spacer>

          <v-btn
          icon
          class="ma-0"
          color="blue"
          :disabled="page <= 0"
          @click="page--">
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>

          <v-btn
          icon
          color="blue"
          class="ma-0"
          :disabled="page >= paginationLength - 1"
          @click="page++">
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-layout>
        <div style="overflow: auto;">

          <!-- new -->
          <!-- simple table -->
          <!-- top toolbar -->

          <table class="final-table lines-r">
            <colgroup ref="colgroup1">
              <col width="400px">
              <col width="200px">
            </colgroup>
            <tr class="unselectable">
              <th class="sticky">
                  Items ({{ items.length }})
                  <div class="handle" @mousedown="startColDrag(0, $event)"></div>
              </th>
              <th>
                Quantity
                <div class="handle" @mousedown="startColDrag(1, $event)"></div>
              </th>
            </tr>
          </table>

          <table class="final-table">
            <colgroup ref="colgroup2">
              <col width="400px">
              <col width="200px">
            </colgroup>
            <packaging-row 
            v-for="item in paginatedArray"
            :vmode="0"
            :key="item.tempID" 
            :item="item"
            :selected="selected"
            @checkRow="checkRow(item)"
            @click.native="clickRow(item)">
            </packaging-row>
          </table>
    
        </div>
          <!-- end new -->

          <!-- PAGINATION -->
          <c-pagination-client
          :page="page"
          :paginationLength="paginationLength"
          :paginatedArray="paginatedArray"
          :rowsPerPage.sync="rowsPerPage"
          @updatePageNumber="updatePageNumber"
          @goToFirstPage="goToFirstPage"
          @goToPreviousPage="goToPreviousPage"
          @goToNextPage="goToNextPage"
          @goToLastPage="goToLastPage">
          </c-pagination-client>
          <!-- PAGINATION -->

          <!-- DIALOGS -->
          <c-select-inv-def-dialog ref="selectItemDialog" :exceptions="exceptionIdArray">
          </c-select-inv-def-dialog>
          
      </div>
    </template>
  </c-expansion-panel>
</template>

<script>
import PackagingRow from './PackagingRow'
import Draggable from 'vuedraggable'
import ListController from '@/mixins/ListController'

export default {
  props: ['id', 'itemsSource'],
  mixins: [ListController],
  components: {
    PackagingRow,
    Draggable
  },
  data () {
    return {
      sortLive: false,
      rowsPerPageOverride: 10,
      colDragEvent: {
        dragging: false,
        mouseXStart: 0,
        startWidth: 0,
        index: 0
      }
    }
  },
  watch: {
    rowsPerPageOverride (nv) {
      if (!isNaN(nv) && nv > 0) {
        this.rowsPerPage = parseInt(nv)
      }
    },
    itemsSource (nv) {
      this.items = nv
    },
    items (nv) {
      this.$emit('update:itemsSource', nv)
    }
  },
  computed: {
    exceptionIdArray () {
      return this.items.map(item => item.inventory_item_id)
    }
  },
  methods: {
    mouseUp (index, e) {
      this.colDragEvent.dragging = false
      this.colDragEvent.index = null
    },
    onMouseMove (e) {
      if (this.colDragEvent.dragging) {
        var distance = this.colDragEvent.startWidth + (e.pageX - this.colDragEvent.startX)
        if (distance < 20) { // minimum cell width (should be positive)
          distance = 20
        }
        this.$refs.colgroup1.children[this.colDragEvent.index].style.width = distance + 'px'
        this.$refs.colgroup2.children[this.colDragEvent.index].style.width = distance + 'px'
      }
    },
    startColDrag (index, event) {
      this.colDragEvent.startWidth = event.target.parentElement.offsetWidth
      this.colDragEvent.startX = event.clientX
      this.colDragEvent.dragging = true
      this.colDragEvent.index = index
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        /* this.selectedItem = item
        this.clonedRow = JSON.parse(JSON.stringify(item))
        this.dialog = true */
      }
    },
    selectOutput () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.items.push({
            definition: Object.assign({}, selectedItem),
            name: selectedItem.name,
            inventory_item_id: selectedItem.id,
            quantity: 0,
            percent: 0,
            type: 0
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' item' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    }
  },
  mounted () {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
  }
}
</script>

<style scoped lang="scss">

</style>
